import {
    RowUsageStats,
    useGetTeamsRowUsageStatsQuery,
} from '../generated/graphql-types';

export const useGetTeamsRowUsageStats = (
    batchSize: number,
    offset = 1,
    sortBy = 'DEFAULT',
    sortAscending = false,
) => {
    const { data, error, loading, refetch } = useGetTeamsRowUsageStatsQuery({
        variables: {
            batchSize,
            offset,
            sortBy,
            sortAscending,
        },
    });
    return {
        error,
        loading,
        data: data?.getTeamsRowUsageStats as RowUsageStats,
        refetch,
    };
};
